export default __webpack_public_path__ + "static/media/logo-css.4061c54b.png";